import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import s from '../CaseFilePage.module.css';

interface EditTaskFormState {
  description: string;
  deadline: string;
  status: string;
}

interface EditTaskModalProps {
  editTaskForm: EditTaskFormState;
  setEditTaskForm: React.Dispatch<React.SetStateAction<EditTaskFormState>>;
  handleUpdateTask: () => void;
  handleDeleteTask: () => void;
  isUpdatePending: boolean;
  isDeletePending: boolean;
  onClose: () => void;
}

export default function EditTaskModal({
  editTaskForm,
  setEditTaskForm,
  handleUpdateTask,
  handleDeleteTask,
  isUpdatePending,
  isDeletePending,
  onClose,
}: EditTaskModalProps) {
  return (
    <ModalOverlay onClose={onClose} title="Edit Task">
      <div className={s.modalForm}>
        <div className={s.formGroup}>
          <label>Description</label>
          <textarea
            rows={3}
            value={editTaskForm.description}
            onChange={(e) => setEditTaskForm((p) => ({ ...p, description: e.target.value }))}
          />
        </div>
        <div className={s.formGroup}>
          <label>Deadline</label>
          <input
            type="datetime-local"
            value={editTaskForm.deadline}
            onChange={(e) => setEditTaskForm((p) => ({ ...p, deadline: e.target.value }))}
          />
        </div>
        <div className={s.formGroup}>
          <label>Status</label>
          <select
            value={editTaskForm.status}
            onChange={(e) => setEditTaskForm((p) => ({ ...p, status: e.target.value }))}
          >
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Overdue">Overdue</option>
          </select>
        </div>
        <div className={s.modalActions}>
          <button className={s.btnDanger} onClick={handleDeleteTask} disabled={isDeletePending}>
            <FontAwesomeIcon icon={faTrash} /> Delete
          </button>
          <div style={{ flex: 1 }} />
          <button className={s.btnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button className={s.btnPrimary} onClick={handleUpdateTask} disabled={isUpdatePending}>
            {isUpdatePending ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faCheck} />
            )}
            Save
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
